// extracted by mini-css-extract-plugin
export default {"current-value-label":"_1_SRJ","currentValueLabel":"_1_SRJ"};